import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCoffee, FiGlassWater, FiHeart, FiMic, FiMusic, FiCamera } = FiIcons;

const Experience = () => {
  const experiences = [
    { icon: FiCoffee, title: "Welcome Arrival", desc: "A warm greeting in our historic courtyards." },
    { icon: FiGlassWater, title: "Cocktail Hour", desc: "Premium bar service and passed hors d'oeuvres." },
    { icon: FiHeart, title: "Holiday Dinner", desc: "Elevated catering tailored to your corporate tastes." },
    { icon: FiMic, title: "Toasts & Recognition", desc: "Proper A/V setup for leadership speeches." },
    { icon: FiMusic, title: "Music & Dancing", desc: "Spacious areas for entertainment and celebration." },
    { icon: FiCamera, title: "Photo Moments", desc: "Stunning architectural backdrops for team photos." }
  ];

  return (
    <section className="py-32 bg-mission-green text-spanish-ivory relative overflow-hidden">
      <div className="absolute inset-0 bg-tile-pattern opacity-5"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row gap-20 items-center">
          <div className="lg:w-1/3">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-antique-gold font-sans font-semibold uppercase tracking-[0.2em] text-xs mb-4 block">The Experience</span>
              <h2 className="font-serif text-4xl md:text-5xl mb-8 leading-tight">
                Dinner. Drinks. <br /> Music. Memories.
              </h2>
              <p className="text-spanish-ivory/80 text-lg leading-relaxed mb-8">
                From arrival to the final toast, Padua gives your holiday party a natural flow — welcome drinks, seated dinner, speeches, awards, and space for your team to actually enjoy the night.
              </p>
              <div className="h-0.5 w-16 bg-antique-gold"></div>
            </motion.div>
          </div>
          
          <div className="lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {experiences.map((exp, idx) => (
              <motion.div 
                key={idx}
                className="bg-mission-dark/40 backdrop-blur-sm p-8 rounded border border-olive-sage/20 hover:border-antique-gold/40 transition-all duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 * idx }}
              >
                <div className="flex flex-col h-full">
                  <SafeIcon icon={exp.icon} className="text-antique-gold text-2xl mb-6" />
                  <h4 className="font-serif text-xl mb-3 text-spanish-ivory">{exp.title}</h4>
                  <p className="text-sm text-spanish-ivory/60 leading-relaxed">{exp.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;